import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const networkStorageRoutes = {
  [ERouteMappingKeys.NETWORK_STORAGE]: {
    id: "network-storage",
    path: "/integrations/network-storage",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/Integrations/NetworkStorage").then((p) => ({
          default: p.NetworkStorage,
        })),
      ),
    },
  },
};
